if (typeof customElements.get('discount-notice') === 'undefined') {
  class DiscountNotice extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      const cartItemCount = Number(this.getAttribute('data-cart-item-count'));
      const discountItemThreshold = Number(this.getAttribute('data-item-threshold')) || 3;

      const discountProgress = Math.min(cartItemCount / discountItemThreshold, 1) * 100;

      const discountBar = this.querySelector('[data-js-discount-segment]');
      const messageEl = this.querySelector('[data-js-discount-text]');
      const iconEl = this.querySelector('[data-js-discount-icon]');

      const translationRemaining = this.getAttribute('data-translation-remaining');
      const translationReached = this.getAttribute('data-translation-reached');

      if (discountBar) {
        discountBar.style.width = `${discountProgress}%`;
      }

      if (iconEl) {
        iconEl.style.left = `${discountProgress}%`;
        iconEl.textContent = discountProgress === 100 ? '🎉' : '🛍';
      }

      if (!messageEl) return;

      const itemsLeft = discountItemThreshold - cartItemCount;

      if (discountProgress === 100) {
        messageEl.textContent = translationReached;
      } else {
        const localized = translationRemaining.replace('{{ count }}', itemsLeft);
        messageEl.textContent = localized;
      }
    }
  }

  customElements.define('discount-notice', DiscountNotice);
}
